import { jsx } from 'react/jsx-runtime';
import Image from 'next/image';
import { buildURL } from 'imgix-url-builder';
import * as prismicH from '@prismicio/helpers';
import { __PRODUCTION__ } from './lib/__PRODUCTION__.mjs';
import { devMsg } from './lib/devMsg.mjs';

const imgixLoader = (args) => {
  const url = new URL(args.src);
  const params = {
    fit: url.searchParams.get("fit") || "max",
    w: args.width,
    h: void 0
  };
  if (args.quality) {
    params.q = args.quality;
  }
  return buildURL(args.src, params);
};
const PrismicNextImage = ({
  field,
  imgixParams = {},
  alt,
  fallbackAlt,
  layout,
  ...restProps
}) => {
  if (!__PRODUCTION__) {
    if (typeof alt === "string" && alt !== "") {
      console.warn(
        `[PrismicNextImage] The "alt" prop can only be used to declare an image as decorative by passing an empty string (alt="") but was provided a non-empty string. You can resolve this warning by removing the "alt" prop or changing it to alt="". For more details, see ${devMsg(
          "alt-must-be-an-empty-string"
        )}`
      );
    }
    if (typeof fallbackAlt === "string" && fallbackAlt !== "") {
      console.warn(
        `[PrismicNextImage] The "fallbackAlt" prop can only be used to declare an image as decorative by passing an empty string (fallbackAlt="") but was provided a non-empty string. You can resolve this warning by removing the "fallbackAlt" prop or changing it to fallbackAlt="". For more details, see ${devMsg(
          "alt-must-be-an-empty-string"
        )}`
      );
    }
  }
  if (prismicH.isFilled.imageThumbnail(field)) {
    const src = buildURL(field.url, imgixParams);
    return /* @__PURE__ */ jsx(Image, {
      src,
      width: layout === "fill" ? void 0 : field.dimensions.width,
      height: layout === "fill" ? void 0 : field.dimensions.height,
      alt: alt ?? (field.alt || fallbackAlt),
      loader: imgixLoader,
      layout,
      ...restProps
    });
  } else {
    return null;
  }
};

export { PrismicNextImage };
//# sourceMappingURL=PrismicNextImage.mjs.map
